import { Token } from '@uniswap/sdk-core'
import { computePoolAddress as computePoolAddressDefault, FeeAmount } from '@uniswap/v3-sdk'
import { V3_CORE_FACTORY_ADDRESSES } from 'constants/addresses'
import { SupportedChainId } from 'constants/chains'

import { computePoolAddressZk } from './computePoolAddressZk'

const POOL_INIT_CODE_HASH = '0x30146866f3a846fe3c636beb2756dbd24cf321bc52c9113c837c21f47470dfeb'

interface Props {
  chainId: SupportedChainId
  tokenA: Token
  tokenB: Token
  fee: FeeAmount
}

export function computePoolAddress({ chainId, tokenA, tokenB, fee }: Props) {
  if (chainId === SupportedChainId.ARBITRUM) {
    return computePoolAddressDefault({
      factoryAddress: V3_CORE_FACTORY_ADDRESSES[chainId],
      tokenA,
      tokenB,
      fee,
      initCodeHashManualOverride: '0xe34f199b19b2b4f47f68442619d555527d244f78a3297ea89325f843f87b8b54',
    })
  }
  if (chainId !== SupportedChainId.ZK_SYNC) {
    return computePoolAddressDefault({
      factoryAddress: V3_CORE_FACTORY_ADDRESSES[chainId],
      tokenA,
      tokenB,
      fee,
      initCodeHashManualOverride: POOL_INIT_CODE_HASH,
    })
  }

  return computePoolAddressZk({ tokenA, tokenB, fee })
}
